import { ADDON_CAVE_BUNDLES, CAVE_FOLD_RACK_SKU, CAVE_PANEL_LEFT_SKU, CAVE_PANEL_RIGHT_SKU, CAVE_RACK_SKU, CAVE_SKUS, MAIN_CAVE_BUNDLE } from '@/js/pages/product/rackbuilder/products/cave/utils/caveConstants'
import { EMAIL_UNIT_KEY } from '../emailKeys'
import type { BuyRequest, IRogue } from '@/js/services/RogueTypes'
import type { CustomProductVariant } from '../types'

// Each Cave bundle carries one section-delimiter child (Rack / Panel Left / Panel Right) that neither the cart nor the order PDF lists as an item; it names the section instead.
function getCaveSectionLabel(rogue: IRogue, child: BuyRequest): string | undefined {
  const sku = rogue.getProductById(child.productId)?.sku

  if (sku === CAVE_RACK_SKU || sku === CAVE_FOLD_RACK_SKU) return rogue.__('Rack')
  if (sku === CAVE_PANEL_LEFT_SKU) return rogue.__('Left Side')
  if (sku === CAVE_PANEL_RIGHT_SKU) return rogue.__('Right Side')

  return undefined
}

export const caveVariant: CustomProductVariant = {
  id          : 'cave',
  featureFlag : 'enable_cave_2',

  matches: (product, groupProduct) => {
    const sku = product?.sku
    const groupSku = groupProduct?.sku

    return (!!sku && CAVE_SKUS.includes(sku)) || (!!groupSku && CAVE_SKUS.includes(groupSku))
  },

  skuSets: {
    allSkus              : CAVE_SKUS,
    itemSkus             : CAVE_SKUS,
    mainSkus             : [MAIN_CAVE_BUNDLE],
    qtyExcludedSkus      : ADDON_CAVE_BUNDLES,
    addCountExcludedSkus : ADDON_CAVE_BUNDLES,
  },

  // Cave joins its sibling bundles (main/left/right) via metadata.recipe.
  purchaseKey: (item) => item.metadata?.recipe,

  // m2-checkout sorts a recipe's lines by unitNumber and leaves unnumbered ones in list order, which is not Rack → Left → Right in the order or the confirmation email; the group's children already are.
  prepareForCart: (buyRequest) => {
    buyRequest.children?.forEach((child, index) => {
      child.metadata ??= {}
      child.metadata.unitNumber = index + 1
    })
  },

  emailLayout: (rogue, unit, child) => {
    const label = getCaveSectionLabel(rogue, child)

    return label ? { [EMAIL_UNIT_KEY]: label } : undefined
  },
}
